module.exports = __webpack_public_path__ + "public/img/touxiang.fca74196.png";